import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';

import { Cell } from './Cell';
import { Controls } from './Controls';
import { t } from '../../services/translation/translation';

type Props = {
  year: number;
  month: number;
  onSelectMonth: (_month: number) => void;
  setYear: Dispatch<SetStateAction<number>>;
  onHeaderClick: () => void;
};

export const MonthView = ({ year, month, onSelectMonth, setYear, onHeaderClick }: Props) => {
  const handlePrevious = () => {
    setYear(year - 1);
  };

  const handleNext = () => {
    setYear(year + 1);
  };

  return (
    <div>
      <Controls
        onHeaderClick={onHeaderClick}
        onPrevious={handlePrevious}
        onNext={handleNext}
        label={dayjs({ year, month }).format(t('date-picker.months'))}
      />
      <div className="w-64 grid grid-cols-4">
        {Array.from({ length: 12 }).map((_, index) => (
          <Cell key={index} isSelected={month === index} onClick={() => onSelectMonth(index)}>
            {dayjs().month(index).format('MMM')}
          </Cell>
        ))}
      </div>
    </div>
  );
};
